'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./DocumentModeCanvasElementDebugger.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The overlay colour will be picked depending on the index of the cluster it's within
var CLUSTER_COLORS = ['rgba(255, 255, 0, 0.5)', // yellow
'rgba(127, 219, 255, 0.5)', // blue
'rgba(46, 204, 64, 0.5)', // green
'rgba(240, 18, 190, 0.5)', // maroon
'rgba(57, 204, 204, 0.5)', // teal
'rgba(255, 133, 27, 0.5)', // orange
'rgba(255, 65, 54, 0.5)', // red
'rgba(1, 255, 112, 0.5)'];

// Styles
// Lib


var getElementBorderStyle = function getElementBorderStyle(gridSize, elementClusterData, clusterIndex) {
    var bounds = elementClusterData.getIn(['cluster', 'bounds']).toJS();
    var colourIndex = (clusterIndex - 1) % CLUSTER_COLORS.length;

    return {
        top: bounds.top * gridSize,
        left: bounds.left * gridSize,
        width: (bounds.right - bounds.left) * gridSize,
        height: (bounds.bottom - bounds.top) * gridSize,
        background: CLUSTER_COLORS[colourIndex]
    };
};

var DocumentModeCanvasElementDebugger = function DocumentModeCanvasElementDebugger(_ref) {
    var gridSize = _ref.gridSize,
        elementClusterData = _ref.elementClusterData,
        clusterIndex = _ref.clusterIndex,
        elementOrder = _ref.elementOrder;

    var elementId = elementClusterData.getIn(['cluster', 'id']);
    var order = elementOrder.indexOf(elementId) + 1;

    return _react2.default.createElement(
        'div',
        { className: 'DocumentModeCanvasElementDebugger',
            style: getElementBorderStyle(gridSize, elementClusterData, clusterIndex) },
        _react2.default.createElement(
            'span',
            { className: 'order' },
            order
        ),
        _react2.default.createElement(
            'span',
            { className: 'element-id' },
            elementId.substr(-4)
        )
    );
};

DocumentModeCanvasElementDebugger.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    clusterIndex: _propTypes2.default.number.isRequired,
    columnIndex: _propTypes2.default.number.isRequired,
    elementClusterData: _propTypes2.default.object.isRequired,
    elementOrder: _propTypes2.default.object.isRequired
};

exports.default = DocumentModeCanvasElementDebugger;


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeCanvasElementDebugger.js
// module id = 1943
// module chunks = 0